import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import MerchantOrdersExport from '@/components/v2/network_distributor/MerchantOrdersExport';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ActionButton from '@/components/action_button/Index.vue';
import BaseCsvExporter from '@/components/v2/BaseCsvExporter.vue';
import moment from 'moment';
let MerchantOrderExport = class MerchantOrderExport extends Mixins(ViewportSizeMixin, AlertMixin) {
    get labels() {
        const labels = {
            transactionNumber: 'Transaction Number',
            productName: 'First Product',
            customerName: 'Customer Name',
            amount: 'Grand Total',
            paymentMethod: 'Payment Method',
            orderDate: 'Order Date',
        };
        return labels;
    }
    get fields() {
        return Object.keys(this.labels);
    }
    get csvName() {
        const timestamp = moment().unix();
        return `order_history_${timestamp}`;
    }
    alertError(orders) {
        if (!orders || orders.length === 0) {
            this.errorNotification('No data to export');
        }
    }
};
__decorate([
    Prop({ type: String, required: true })
], MerchantOrderExport.prototype, "merchantUuid", void 0);
MerchantOrderExport = __decorate([
    Component({
        components: {
            MerchantOrdersExport,
            ActionButton,
            BaseCsvExporter,
        },
    })
], MerchantOrderExport);
export default MerchantOrderExport;
